<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-pulse py-7 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <img src="/img/pulse/pulse-logo-white.png" style="width: 200px;">
              <h3 class="text-white mt-2">Powered by ClarityNOW</h3>
              <h1 class="text-white">Sign up and get Clarity on your business NOW!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <!-- Table -->
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div v-if="step == 0">
            <b-row class="justify-content-center">
              <b-col md="8">
                <b-card>
                  <b-card-body>
                    <div class="text-center text-muted mb-4">
                      <h2>Registration</h2>
                      <small>Have an account? Then please <a href="/">Login Here</a></small>
                    </div>
                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-hat-3"
                                placeholder="Name"
                                name="Name"
                                :rules="{required: true}"
                                v-model="model.name">
                    </base-input>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-email-83"
                                placeholder="Email"
                                name="Email"
                                :rules="{required: true, email: true}"
                                v-model="model.email">
                    </base-input>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-lock-circle-open"
                                placeholder="Password"
                                type="password"
                                name="Password"
                                :rules="{required: true, min: 6}"
                                v-model="model.password"
                                ref="password">
                    </base-input>
                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-lock-circle-open"
                                placeholder="Confirm Password"
                                type="password"
                                name="Confirm Password"
                                :rules="{required: true, min: 6, is: model.password}"
                                v-model="model.password_confirmation">
                    </base-input>
                    <div class="text-center">
                      <b-button class="pulse-btn" block variant="danger" @click="step = 1">NEXT</b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>

          <div v-if="step == 1">
            <b-row class="justify-content-center">
              <b-col md="8">
                <b-card>
                  <b-card-body>
                    <div class="text-center text-muted mb-4">
                      <h2>Registration</h2>
                      <small>Have an account? Then please <a href="/">Login Here</a></small>
                    </div>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-map-big"
                                placeholder="City"
                                name="City"
                                :rules="{required: true}"
                                v-model="model.city">
                    </base-input>

                    <base-input>
                      <state-select v-model="model.state" :required="true"></state-select>
                    </base-input>

                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-mobile-button"
                                placeholder="Phone"
                                name="Phone"
                                :rules="{required: true}"
                                v-model="model.phone">
                    </base-input>

                    
                    <base-input alternative
                                class="mb-3"
                                prepend-icon="ni ni-hat-3"
                                placeholder="e.g. Company or Team Name"
                                name="Team Name"
                                :rules="{required: true}"
                                v-model="model.team">
                    </base-input>
                    <base-input label-for="team_member" name="Realty Role">
                      <el-select v-model="model.realty_role" placeholder="Select Real Estate Role">
                        <el-option v-for="(role, index) in roles"
                                   :key="index"
                                   :label="role.text"
                                   :value="role.value">
                        </el-option>
                      </el-select>
                    </base-input>

                    <div v-if="errors">
                      <ul class="text-danger">
                        <li v-for="(error, index) in errors" :key="index" class="small">
                          {{ error.toString() }}
                        </li>
                      </ul>
                    </div>

                    <div class="text-center mt-4 d-flex">
                      <b-button variant="outline-danger" @click="step = 2" class="flex-fill outline-pulse">BACK</b-button>
                      <b-button type="submit" variant="danger" :disabled="disabled" class="flex-fill pulse-btn"><span v-html="registerBtn"></span></b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import StateSelect from "@/views/Components/Forms/StateSelect";
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";

export default {
  name: 'register',
  mixins: [errorsMixin],
  components: {
    StateSelect,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      model: {
        name: '',
        email: '',
        city: '',
        state: '',
        phone: '',
        password: '',
        password_confirmation: '',
        team: '',
        realty_role: null,
        affiliate: '',
        pulse: true
      },
      roles: [
        {
          value: 'Rainmaker',
          text: 'Rainmaker'
        },
        {
          value: 'Solo Agent',
          text: 'Solo Agent'
        },
        {
          value: 'Listing Agent',
          text: 'Listing Agent'
        },
        {
          value: 'Buyers Agent',
          text: 'Buyers Agent'
        },
        {
          value: 'Admin',
          text: 'Admin'
        },
        {
          value: 'ISA',
          text: 'ISA'
        },
        {
          value: 'Real Estate Coach',
          text: 'Real Estate Coach'
        },
        {
          value: 'Other',
          text: 'Other'
        },
      ],
      errors: null,
      registerBtn: 'REGISTER',
      disabled: false,
      step: 0,
      name: null
    }
  },
  computed: {
    passwordConfirmed() {
      return this.model.password == this.model.confirm_password;
    },
    user() {
      return this.$store.getters['profile/user'];
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
  },
  methods: {
    async onSubmit() {
      this.disabled = true;
      this.registerBtn = '<i class="fas fa-spinner fa-pulse"></i> PROCESSING...';

      axios.post(process.env.VUE_APP_API_BASE_URL + "/register", this.model)
      .then(response => {
        this.login();
        this.partnerStackSignup();
      })
      .catch(error => {
        this.registerBtn = 'REGISTER';
        this.errors = error.response.data.errors;
        this.error(error);
      });
    },
    async login() {
      const user = {
        email: this.model.email,
        password: this.model.password
      }

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });        
        swal.fire({
          title: `Success`,
          text: 'Welcome to ClarityNOW!',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.setupStore();

          this.$router.push({
            path: '/home'
          });
        });
      } catch(error) {
        this.error(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    partnerStackSignup() {
      growsumo.data.name = this.model.name;
      growsumo.data.email = this.model.email;
      growsumo.data.customer_key = this.model.email;
      growsumo.createSignup();
    },
    setupStore() {
      this.$store.dispatch("roles/get");
      this.$store.dispatch("teams/get", {user: this.user.slug});
      this.$store.dispatch("teams/member", {user: this.user.slug});
    }
  },
  created() {
    if (this.$route.query.ppw && this.$route.query.ppw == 'f260VQJRi4AUwwlC') {
      return;
    } else {
      this.$router.push({
        path: '/register'
      });
    }
  }
};
</script>
<style lang="scss">
.plans {
  .card-body {
    padding-top: 10px;
    background-image: url('/img/plans-background.png');
    background-size: 100% auto;
  }
  .card-title {
    margin-bottom: 0;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0px 0px 1px #222222;
    color: #CE5E5E;
  }
  h1 {
    text-transform: uppercase;
    font-weight: bold;
  }
  h5 {
    font-weight: bold;
    padding-top: 2px;
    padding-bottom: 2px;
    text-align: center;
    text-transform: uppercase;
  }

  ul {
    font-size: 13px;
    margin-bottom: 0.5rem;
    font-weight: normal;

    li {
      line-height: 19px;
    }
  }
}

.bg-light-blue {
  background-color: rgba(173, 216, 230, 0.3);

}
.bg-gradient-pulse {
  background: linear-gradient(87deg, #262262 40%, #DDB143 100%) !important
}
.pulse-btn {
  background-color: #262262 !important;
  border-color: #262262 !important;
}
.outline-pulse {
  border-color: #DDB143 !important;
  color: #DDB143 !important;
}
</style>
